export type TimeOption = {
  date: Date;
};

export const SCHEDULE_OPTIONS = {
  ASAP: 'asap',
  SCHEDULED_DATE: 'scheduled-date',
} as const;

export type ScheduleOption =
  (typeof SCHEDULE_OPTIONS)[keyof typeof SCHEDULE_OPTIONS];

export type ServiceRequestScheduleState = {
  scheduleOption: ScheduleOption;
  selectedDate: Date | null;
  selectedTime: Date | null;
  timeSlots: TimeOption[];
  minDate: Date | undefined;
  isValid: boolean;
};

export type ServiceRequestScheduleActions = {
  handleScheduleOptionChange: (option: ScheduleOption) => void;
  handleDateChange: (date: Date) => void;
  handleTimeChange: (value: string) => void;
};

export type UseServiceRequestScheduleReturn = ServiceRequestScheduleState &
  ServiceRequestScheduleActions;
